import * as Types from '@trello/graphql/generated';

import DocumentNode from '@trello/graphql/documentNode';
import * as Apollo from '@apollo/client';
export const AcceptDeveloperTermsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"AcceptDeveloperTerms"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"memberId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"acceptDeveloperTerms"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"memberId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"memberId"}}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"client"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"agreementType"}}]}}]}}]} as unknown as DocumentNode;
const defaultOptions = {"context":{"operationName":"AcceptDeveloperTerms","document":AcceptDeveloperTermsDocument}} as const;
export type AcceptDeveloperTermsMutationVariables = Types.Exact<{
  memberId: Types.Scalars['ID']['input'];
}>;


export type AcceptDeveloperTermsMutation = (
  { __typename: 'Mutation' }
  & { acceptDeveloperTerms?: Types.Maybe<(
    { __typename: 'Member_Agreement' }
    & Pick<Types.Member_Agreement, 'id' | 'agreementType'>
  )> }
);

export type AcceptDeveloperTermsMutationFn = Apollo.MutationFunction<
  AcceptDeveloperTermsMutation,
  AcceptDeveloperTermsMutationVariables
>;

/**
 * __useAcceptDeveloperTermsMutation__
 *
 * To run a mutation, you first call `useAcceptDeveloperTermsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAcceptDeveloperTermsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [acceptDeveloperTermsMutation, { data, loading, error }] = useAcceptDeveloperTermsMutation({
 *   variables: {
 *      memberId: // value for 'memberId'
 *   },
 * });
 */
export function useAcceptDeveloperTermsMutation(
  baseOptions?: Apollo.MutationHookOptions<
    AcceptDeveloperTermsMutation,
    AcceptDeveloperTermsMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    AcceptDeveloperTermsMutation,
    AcceptDeveloperTermsMutationVariables
  >(AcceptDeveloperTermsDocument, options);
}
export type AcceptDeveloperTermsMutationHookResult = ReturnType<
  typeof useAcceptDeveloperTermsMutation
>;
export type AcceptDeveloperTermsMutationResult =
  Apollo.MutationResult<AcceptDeveloperTermsMutation>;
export type AcceptDeveloperTermsMutationOptions = Apollo.BaseMutationOptions<
  AcceptDeveloperTermsMutation,
  AcceptDeveloperTermsMutationVariables
>;
